import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HOURS = Array.from({ length: 19 }, (_, i) => String(i + 5).padStart(2, "0"));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

export const SCHEDULE_TIME_PATTERN = /^([01]\d|2[0-3]):[0-5][05]$/;

interface ScheduleTimePickerProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** Sélecteur heure + minutes (pas de 5 min) produisant une valeur "HH:mm". */
export function ScheduleTimePicker({ id, value, onChange, disabled }: ScheduleTimePickerProps) {
  const [hour = "08", minute = "00"] = value.split(":");
  const hours = HOURS.includes(hour) ? HOURS : [...HOURS, hour].sort();
  const minutes = MINUTES.includes(minute) ? MINUTES : [...MINUTES, minute].sort();

  return (
    <div className="flex items-center gap-2">
      <Select value={hour} onValueChange={(h) => onChange(`${h}:${minute}`)} disabled={disabled}>
        <SelectTrigger id={id} className="w-full" aria-label="heure">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {hours.map((h) => <SelectItem key={h} value={h}>{h}</SelectItem>)}
        </SelectContent>
      </Select>
      <span className="text-muted-foreground">:</span>
      <Select value={minute} onValueChange={(m) => onChange(`${hour}:${m}`)} disabled={disabled}>
        <SelectTrigger className="w-full" aria-label="minutes">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {minutes.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
